/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';

/**
 * 
 * @export
 * @interface LocationSearchDto
 */
export interface LocationSearchDto {
    /**
     * 
     * @type {number}
     * @memberof LocationSearchDto
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof LocationSearchDto
     */
    locationName: string;
    /**
     * 
     * @type {CountryCode}
     * @memberof LocationSearchDto
     */
    countryCode: CountryCode;
}



/**
 * Check if a given object implements the LocationSearchDto interface.
 */
export function instanceOfLocationSearchDto(value: object): value is LocationSearchDto {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function LocationSearchDtoFromJSON(json: any): LocationSearchDto {
    return LocationSearchDtoFromJSONTyped(json, false);
}

export function LocationSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationSearchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'locationName': json['locationName'],
        'countryCode': CountryCodeFromJSON(json['countryCode']),
    };
}

export function LocationSearchDtoToJSON(json: any): LocationSearchDto {
    return LocationSearchDtoToJSONTyped(json, false);
}

export function LocationSearchDtoToJSONTyped(value?: LocationSearchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'locationName': value['locationName'],
        'countryCode': CountryCodeToJSON(value['countryCode']),
    };
}

